var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.921,
    height: 59.921,
    viewBox: "0 0 59.921 59.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(-75.368 -721.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(-3411 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    transform: "translate(3488.828 728.702)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.46
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 2.992,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.23,
    y: -1.23,
    width: 57.46,
    height: 57.46,
    rx: 4.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    d: "M0,0H33.322a0,0,0,0,1,0,0V19.506a2.763,2.763,0,0,1-2.763,2.763H2.763A2.763,2.763,0,0,1,0,19.506V0A0,0,0,0,1,0,0Z",
    transform: "translate(3499.667 748.392)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 3.89,
    height: 1.958,
    transform: "translate(3495.777 750.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 3.89,
    height: 1.958,
    transform: "translate(3532.99 750.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M3532.99,746.026v-1.815s-3.372-4.927-16.662-4.927-16.661,4.927-16.661,4.927v1.815Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M3521.684,741.1h-1.958a3.4,3.4,0,0,0-6.794,0h-1.958a5.355,5.355,0,0,1,10.71,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M3516.328,771.958c2.447,1.58,1.7,4.7,0,4.7S3513.882,773.538,3516.328,771.958Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M3510.972,771.958c2.447,1.58,1.7,4.7,0,4.7S3508.526,773.538,3510.972,771.958Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M3521.684,771.958c2.446,1.58,1.7,4.7,0,4.7S3519.237,773.538,3521.684,771.958Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPan);
export default __webpack_public_path__ + "static/media/icon-pan.0fefa04663aed2395af31696334d08a4.svg";
export { ForwardRef as ReactComponent };